<template>
    <div class="general-tab">
        <div
            class="tabulation-title"
            :style="'color:' + titlesColor">

            <h5 :class="uskaForm && 'mt-0'">{{ index }}. Informations générales</h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <form-component-loader :fields="tabulationFields"></form-component-loader>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters} from "vuex"
import FormComponentLoader from "../FormComponentLoader.vue"

export default {
    name: "General",
    components: {FormComponentLoader},
    props: ["index", "uskaForm"],
    methods: {
        handleAIContent(res) {
            this.provider.contents.forEach((content) => {
                if (content.language.code === "fr") {
                    if (res.type === 'SHORT') {
                        content.description = res.content
                    } else {
                        content.description_long = res.content
                    }
                }
            })
        },
    },
    computed: {
        ...mapState("web_form", ["provider"]),
        ...mapState("webFormStyle", ["titlesColor"]),
        ...mapState("resource", ["languages"]),
        ...mapGetters("web_form", ["getFieldsFromTabulation"]),
        tabulationFields() {
            let categoryFields = this.getFieldsFromTabulation(this.provider.category.name).sort((a, b) => a.order - b.order)
            let partyMenu = categoryFields.find(field => field.fieldable.code === 'DESC_PARTY_MENU')

            let fields = this.getFieldsFromTabulation('GENERAL').sort((a, b) => a.order - b.order)

            if (partyMenu !== undefined) {
                fields.push(partyMenu)
            }

            return fields
        }
    },
    created() {
        this.$global.$on('accept-ai-content', this.handleAIContent)
    },
    beforeDestroy() {
        this.$global.$off('accept-ai-content')
    }
}
</script>